import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useState 
} from "react"

import {
  useGoogleReCaptcha 
} from "@/common/hooks/useGoogleReCaptcha"

export const useForgotPassword = (props) => {
  const {
    onCancel, mutations 
  } = props

  const [hasCompleted, setCompleted] = useState(false)
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState(null)

  const [
    requestResetEmail,
    {
      error: requestResetEmailError, loading: isResettingPassword 
    },
  ] = useMutation(mutations.requestPasswordResetEmailMutation)

  const {
    recaptchaLoading, generateReCaptchaData, recaptchaWidgetProps 
  } =
        useGoogleReCaptcha({
          currentForm: "CUSTOMER_FORGOT_PASSWORD",
          formAction: "forgotPassword",
        })

  const handleFormSubmit = useCallback(
    async (formState) => {
      const {
        email 
      } = formState.values

      try {
        const reCaptchaData = await generateReCaptchaData()

        await requestResetEmail({
          variables: {
            email 
          },
          ...reCaptchaData,
        })

        setForgotPasswordEmail(email)
        setCompleted(true)
      } catch (error) {
        // Error is logged by apollo link - no need to double log.

        setCompleted(false)
      }
    },
    [generateReCaptchaData, requestResetEmail]
  )

  const handleCancel = useCallback(() => {
    onCancel()
  }, [onCancel])

  return {
    forgotPasswordEmail,
    formErrors: [requestResetEmailError],
    handleCancel,
    handleFormSubmit,
    hasCompleted,
    isResettingPassword: isResettingPassword || recaptchaLoading,
    recaptchaWidgetProps,
  }
}
